/**
 * @param InputRadio Base widget for extending
 * @returns Extended Input Radio widget
 */
function CoreInputRadioClassCreator(InputRadio: import('widgets/forms/InputRadio').TInputRadio) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class CoreInputRadio
     * @augments InputRadio
     * @classdesc Extended Input Radio component with next features:
     * 1. Allows disselect radio button
     */
    class CoreInputRadio extends InputRadio {
        checkedValue = '';

        prefs() {
            return {
                preSelectedValues: '',
                allowDisselect: false,
                ...super.prefs()
            };
        }

        /**
         * Pre-select radio if such value was passed
         */
        init() {
            super.init();

            if (this.prefs().preSelectedValues) {
                this.setValue(this.prefs().preSelectedValues);
            }
        }

        onClick() {
            if (this.prefs().allowDisselect) {
                const checked = this.getChecked();

                if (checked && checked instanceof HTMLInputElement && checked.type === 'radio' && checked.value === this.checkedValue) {
                    checked.checked = false;
                    checked.removeAttribute('checked');
                    this.checkedValue = '';
                }
            }

            this.checkedValue = this.getValue();
        }
    }

    return CoreInputRadio;
}

export type TCoreInputRadio = ReturnType<typeof CoreInputRadioClassCreator>;

export type TCoreInputRadioInstance = InstanceType<TCoreInputRadio>;

export default CoreInputRadioClassCreator;
